import { render, staticRenderFns } from "./GoodsSelector.vue?vue&type=template&id=90ffcfd8&scoped=true&"
import script from "./GoodsSelector.vue?vue&type=script&lang=js&"
export * from "./GoodsSelector.vue?vue&type=script&lang=js&"
import style0 from "./GoodsSelector.vue?vue&type=style&index=0&id=90ffcfd8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90ffcfd8",
  null
  
)

export default component.exports